import cx from "classnames";
import {attr, Component} from "../Component";
import {element} from "../CustomElement";

const LINKS = {
		"olayAgeDefy": {
			link: "https://bit.ly/3nLRczS",
			image: "ULP+Tile+-+2UP-Highres/ULP+Tile+2up+-+Item+1+-+Olay+Age+Defy+Gift+Set.png",
		},
		"olayMegaPack": {
			link: "https://bit.ly/3COQI07",
			image: "ULP+Tile+-+2UP-Highres/ULP+Tile+2up+-+Item+2+-+Olay+Mega+Pack+Gift+Set.png",
		},
		"olayRegenerist": {
			link: "https://bit.ly/3xhMHQS",
			image: "ULP+Tile+-+2UP-Highres/ULP+Tile+2up+-+Item+3+-+Olay+Regenerist+Trial+Gift+Set.png",
		},
		"oldSpiceSwagger": {
			link: "https://bit.ly/3nRHsEf",
			image: "ULP+Tile+-+2UP-Highres/ULP+Tile+2up+-+Item+4+-+Old+Spice+Swagger+Mega+Bag.png",
		},
		"oldSpiceWild": {
			link: "https://bit.ly/3xjF1gK",
			image: "ULP+Tile+-+2UP-Highres/ULP+Tile+2up+-+Item+5+-+Old+Spice+Wild+Pack.png",
		},
		"ivoryGentle": {
			link: "https://bit.ly/3rekZTQ",
			image: "ULP+Tile+-+2UP-Highres/ULP+Tile+2up+-+Item+6+-+Ivory+Gentle+Gift+Set.png",
		},
};

const IMAGES_FOLDER = "https://f.wishabi.net/creative/Distribution/images";

@element("flipp-pgcampaign-page")
export class PGCampaignPage extends Component<{}, void> {
	handleNavigate(key: string) {
		// @ts-ignore
		window.open(LINKS[key]["link"], "_blank");
	}

	getImageLink(key: string) {
		// @ts-ignore
		return `${IMAGES_FOLDER}/${LINKS[key]["image"]}`;
	}

	render() {
		return (
			<main>
				<div class={"container"}>
					<img src={`${IMAGES_FOLDER}/P%26G+Gift+Sets+ULP+-+Assets+-+V4/ULP+Banner.png`}/>
					<div class="container-col">
						<div class="container__item" onClick={() => this.handleNavigate("olayAgeDefy")}>
							<img src={this.getImageLink("olayAgeDefy")}/>
						</div>
						<div class="container__item" onClick={() => this.handleNavigate("olayMegaPack")}>
							<img src={this.getImageLink("olayMegaPack")}/>
						</div>
					</div>

					<div class="container-col">
						<div class="container__item" onClick={() => this.handleNavigate("olayRegenerist")}>
							<img src={this.getImageLink("olayRegenerist")}/>
						</div>
						<div class="container__item" onClick={() => this.handleNavigate("oldSpiceSwagger")}>
							<img src={this.getImageLink("oldSpiceSwagger")}/>
						</div>
					</div>
					<div class="container-col">
						<div class="container__item" onClick={() => this.handleNavigate("oldSpiceWild")}>
							<img src={this.getImageLink("oldSpiceWild")}/>
						</div>
						<div class="container__item" onClick={() => this.handleNavigate("ivoryGentle")}>
							<img src={this.getImageLink("ivoryGentle")}/>
						</div>
					</div>
				</div>
			</main>
		);
	}
}
